import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useBranding } from "@/contexts/BrandingContext";

const VerifyEmailPage = () => {
  const { fullLogo } = useBranding();
  return (
  <div className="min-h-screen bg-background flex items-center justify-center p-6">
    <div className="max-w-md text-center">
      <img src={fullLogo} alt="Value Gift Vouchers" className="h-44 mx-auto mb-8 object-contain" />
      <div className="w-16 h-16 rounded-full bg-brand-green-lt flex items-center justify-center mx-auto mb-4">
        <Mail className="w-8 h-8 text-brand-green" />
      </div>
      <h1 className="text-2xl font-bold text-foreground mb-2">Check Your Email</h1>
      <p className="text-muted-foreground mb-6">
        We've sent a verification link to your email address. Click the link to verify your account and get started.
      </p>
      <p className="text-sm text-muted-foreground mb-8">
        Didn't receive the email? Check your spam folder or{" "}
        <Link to="/register" className="text-brand-green-dk hover:underline">try signing up again</Link>.
      </p>
      <Link to="/login" className="text-sm text-brand-green-dk hover:text-brand-forest transition-colors">
        ← Back to Sign In
      </Link>
    </div>
  </div>
  );
};

export default VerifyEmailPage;
